import { StyleSheet, Text, View } from 'react-native';
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const SimActNavigation = () => {
	const Stack = createNativeStackNavigator();
	return (
		<Stack.Navigator>
			
		</Stack.Navigator>
	);
};

export default SimActNavigation;

const styles = StyleSheet.create({});
